import { Link } from "@tanstack/react-router";
import { MapPinOff } from "lucide-react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/shell/EmptyState";

/**
 * An unknown URL.
 *
 * Offers the way back rather than only stating the problem — a dead end with
 * no exit is how a mistyped link becomes a reload of the whole application.
 */
export function NotFound() {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <EmptyState
        icon={MapPinOff}
        title="No such page"
        description="That URL does not match anything in this application."
        action={
          <Button size="sm" variant="outline" asChild>
            <Link to="/">Go to the dashboard</Link>
          </Button>
        }
      />
    </div>
  );
}
